import { useState } from 'react'

import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import { useDispatch } from 'react-redux';
import { modalAction } from '../../redux/reducers/Modal';
import { editCategoryAction } from '../../redux/reducers/Edit';

const EditCategory = (props) => {

    const [id, setId] = useState(props.category.id);
    const [name, setName] = useState(props.category.name);
    const [status, setStatus] = useState(props.category.status);
    const dispatch = useDispatch();

    const editThisCategory = () => {
        const categoryEdited = new FormData();
        const dataNames = ["id", 'name', 'status'];

        categoryEdited.append(dataNames[0], id);
        categoryEdited.append(dataNames[1], name);
        categoryEdited.append(dataNames[2], status);
        categoryEdited.append('METHOD', 'PUT');

        dispatch(editCategoryAction(categoryEdited, dataNames, id));
        dispatch(modalAction());
    }

  return (
    <>
        <Grid item xs={ 10 }>
            <h5 style={{ margin: '0' }}>Categoría / editar  </h5>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container sx={{ py: 3 }}>
                <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        value={ name }
                        onChange={ e => setName(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 6 } sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Status"
                        value={ status }
                        onChange={ e => setStatus(e.target.value) }
                        >
                            <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='end' className='pr-2'>
            <PrimaryOutlinedButton onClick={ () => editThisCategory() }>Guardar</PrimaryOutlinedButton>
        </Grid>
    </>
  )
}

export default EditCategory